"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledInput = exports.default = void 0;

var _chunkB2edacfb = require("./chunk-b2edacfb.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _layout = require("./layout.js");

var _TextInputGroup = _interopRequireDefault(require("./TextInputGroup.js"));

require("./chunk-b15f6972.js");

require("./chunk-6104512b.js");

require("./chunk-76875e58.js");

require("./chunk-cb015231.js");

require("./chunk-f2932d1d.js");

require("./chunk-eb19ede6.js");

require("./chunk-8219403d.js");

require("./chunk-48de8464.js");

require("./chunk-e8276423.js");

require("./FormGroup.js");

require("classnames");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = (0, _chunkB2edacfb.a)(["\n  color: ", ";\n  font-family: ", ";\n  font-size: 14px;\n  line-height: 22px;\n  padding: 7px 14px;\n\n  outline: none;\n  border: 1px solid ", ";\n  background-color: ", ";\n  border-radius: 6px;\n\n  min-width: 160px;\n  max-width: 400px;\n  width: 100%;\n\n  &[readonly],\n  &[disabled] {\n    background-color: ", ";\n  }\n\n  &[disabled] {\n    color: ", ";\n    pointer-events: none;\n  }\n\n  &::placeholder {\n    color: ", ";\n  }\n\n  &:focus {\n    border: 1px solid ", ";\n    background-color: ", ";\n    transition: border 0.2s ease, background-color 0.2s ease;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var CTextInput = function CTextInput(props) {
  return _react.default.createElement(StyledInput, (0, _chunkB2edacfb.g)({
    key: props.name,
    is: "input",
    type: "text"
  }, props, {
    onChange: function onChange(e) {
      return props.onChange(e.currentTarget.value);
    }
  }));
};

CTextInput.propTypes = {
  onChange: _propTypes.default.func,
  value: _propTypes.default.string,
  type: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  readOnly: _propTypes.default.bool
};
CTextInput.defaultProps = {
  type: "text",
  value: "",
  disabled: false,
  readOnly: false,
  onChange: function onChange() {}
};
CTextInput.displayName = "CTextInput";
CTextInput.Group = _TextInputGroup.default;
var StyledInput = (0, _styledComponents.default)(_layout.Box).withConfig({
  displayName: "CTextInput__StyledInput",
  componentId: "ul6ej8-0"
})(_templateObject(), function (props) {
  return props.theme["$gray-7"];
}, function (props) {
  return props.theme["$font-muli"];
}, function (props) {
  return props.theme["$gray-1"];
}, function (props) {
  return props.theme["$gray-1"];
}, function (props) {
  return props.theme["$gray-1"];
}, function (props) {
  return props.theme["$gray-4"];
}, function (props) {
  return props.theme["$gray-4"];
}, function (props) {
  return props.theme["$gray-4"];
}, function (props) {
  return props.theme["$gray-1"];
});
exports.StyledInput = StyledInput;
CTextInput.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "CTextInput",
  "props": {
    "type": {
      "defaultValue": {
        "value": "\"text\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "value": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "readOnly": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "onChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    }
  }
};
var _default = CTextInput;
exports.default = _default;
CTextInput.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "CTextInput",
  "props": {
    "type": {
      "defaultValue": {
        "value": "\"text\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "value": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "readOnly": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "onChange": {
      "defaultValue": {
        "value": "function onChange() {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    }
  }
};